"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./BoundedCard.scss");
var _checkForDangerouslySet = require("../../utils/methods/checkForDangerouslySet");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BoundedCardMethods = require("./BoundedCardMethods");
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _CTASectionMethods = require("../CTASection/CTASectionMethods");
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/methods/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const BoundedCard = _ref => {
  let {
    content = {},
    VideoComponent,
    contentfulId
  } = _ref;
  const [override, setOverride] = (0, _react.useState)(false);
  const {
    locale,
    image,
    imageSizes,
    eyebrow,
    header,
    text,
    Link,
    cardAlignment,
    bgColor,
    displayButton,
    buttonSecondary,
    cardLink,
    isFeatured,
    featuredLabel,
    tab
  } = content;
  if (buttonSecondary) {
    cardLink.type = `ter-button--primary--2`;
  }
  const isExternal = (0, _CTASectionMethods.checkForExternalLink)(cardLink?.url);
  const componentText = text?.data && text?.typename && text?.typename === "ContentfulRichTextContent" ? /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-bounded-card__text`,
    "data-sb-field-path": "textContent"
  }, text?.data) : text && /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-bounded-card__text`,
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(text),
    "data-sb-field-path": "textContent"
  });
  const renderCardImage = image => {
    return /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
      focalPointImage: image?.focalPointImage,
      alt: image?.alt,
      fullHeightWrapper: true,
      imageSizes: imageSizes,
      contentfulId: image?.contentfulId,
      tab: tab ? true : false
    });
  };
  const componentJSX = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isFeatured && /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-bounded-card__featured-label",
    "data-sb-field-path": "cardLabel"
  }, featuredLabel), image && /*#__PURE__*/_react.default.createElement("figure", {
    role: "none",
    className: "ter-bounded-card__image",
    "data-sb-field-path": "cardImage"
  }, renderCardImage(image)), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-bounded-card__body`
  }, eyebrow && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-bounded-card__eyebrow",
    "data-sb-field-path": "eyebrow"
  }, eyebrow), header && /*#__PURE__*/_react.default.createElement("h4", {
    className: "ter-bounded-card__header",
    style: {
      fontSize: locale && locale === "de" ? "18px" : ""
    },
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header),
    "data-sb-field-path": "header"
  }), componentText, cardLink && displayButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-bounded-card__link-holder",
    "data-sb-field-path": "cardLink"
  }, (0, _BoundedCardMethods.renderButton)(cardLink, Link, VideoComponent, override, setOverride)), cardLink && !displayButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-bounded-card__link-holder",
    "data-sb-field-path": "cardLink"
  }, (0, _BoundedCardMethods.renderCardLink)(cardLink, Link, isExternal, VideoComponent, override, setOverride))));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-bounded-card 
        ${cardAlignment ? "ter-bounded-card--reverse" : ""} 
        ${displayButton ? "ter-bounded-card--with-button" : ""} 
        ${bgColor === "grey" ? "ter-bounded-card--bg-grey" : "ter-bounded-card--bg-white"}`,
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, componentJSX);
};
var _default = BoundedCard;
exports.default = _default;
BoundedCard.propTypes = {
  content: _propTypes.default.shape({
    image: _propTypes.default.object,
    header: _propTypes.default.string.isRequired,
    subHeader: _propTypes.default.string,
    cardLink: _propTypes.default.shape({
      url: _propTypes.default.string,
      text: _propTypes.default.string.isRequired
    }),
    cardAlignment: _propTypes.default.bool,
    displayButton: _propTypes.default.bool,
    buttonSecondary: _propTypes.default.bool
  }),
  fallbackImage: _propTypes.default.string
};